<template>
  <div>
    <h1>{{ $t('errorPage.title') }}</h1>
    <router-link to="home">{{ $t('errorPage.linkText') }}</router-link>
  </div>
</template>
